import { setWithExpiry } from './localStorage';

type ISession = {
  accessToken: string;
  accessTokenSecondToExpiration: number;
  refreshToken?: string;
  refreshTokenSecondToExpiration?: number;
};

const setSession = (session: ISession) => {
  // Only the access token (a short-lived Bearer) lives in localStorage. The
  // refresh token is the backend's HttpOnly `as_refresh` cookie — never stored
  // in JS-readable storage, so XSS can't exfiltrate it.
  setWithExpiry(
    'accessToken',
    session.accessToken,
    session.accessTokenSecondToExpiration
  );
};

export { setSession };
